module.exports = __webpack_public_path__ + "img/green_071.4aeeebc4.png";